import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function sanitizeText(value: string, maxLength: number): string {
  return value.replace(/<[^>]*>/g, "").slice(0, maxLength);
}
